// Meta (Facebook) Pixel integration
const PIXEL_ID = '1575632477487566'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  // Standard Meta Pixel bootstrap
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
  // eslint-disable-next-line no-console
  console.log('[Meta Pixel] Initialized + PageView tracked:', PIXEL_ID)

  // Inject <noscript> fallback img for users with JS disabled
  try {
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  } catch (e) {
    // ignore
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window === 'undefined' || !window.fbq) {
    // eslint-disable-next-line no-console
    console.warn(
      '[Meta Pixel] fbq not available when trying to track:',
      eventName,
    )
    return
  }
  if (params) {
    window.fbq('track', eventName, params)
  } else {
    window.fbq('track', eventName)
  }
  // eslint-disable-next-line no-console
  console.log('[Meta Pixel] Tracked:', eventName, params || '')
}

export function trackAddToCart(params?: Record<string, any>) {
  trackEvent('AddToCart', {
    content_name: 'El Manual del Gym en el Living',
    content_type: 'product',
    currency: 'USD',
    value: 6.39,
    ...params,
  })
}
